import cn from '@repo/shared/utils/cn';
import style from './index.module.css';
/**
 * use background color to style track and text color to style progress bar
 */
export default function LinearProgressBar({
	className,
}: {
	className?: string;
}) {
	return (
		<div className={className}>
			<span
				className={cn(
					'absolute bg-current h-full left-0 top-0 bottom-0',
					style.bar1,
				)}
			/>
			<span
				className={cn(
					'absolute bg-current h-full left-0 top-0 bottom-0',
					style.bar2,
				)}
			/>
		</div>
	);
}
